import React, { useEffect, useState } from "react";
import {
  getDatabase,
  ref,
  onValue,
  off,
  set,
  remove,
} from "firebase/database";
import app from "../../../firebaseConfig";

// MUI
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

export default function FyrionBodega() {
  const db = getDatabase(app);
  const [bodega, setBodega] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [showItems, setShowItems] = useState({});
  const [totalGlobal, setTotalGlobal] = useState(0);
  const [costoGlobal, setCostoGlobal] = useState(0);


  // Dialogs
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [addForCategory, setAddForCategory] = useState(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteForCategory, setDeleteForCategory] = useState(null);
  const [deleteSubSelection, setDeleteSubSelection] = useState("");

  // EDIT dialog
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  const [editSubName, setEditSubName] = useState("");
  const [editData, setEditData] = useState(null);
  const [editChanged, setEditChanged] = useState(false);

  // Form add
  const [newName, setNewName] = useState("");
  const [newCantidad, setNewCantidad] = useState(0);
  const [newCosto, setNewCosto] = useState(0);
  const [newPrecio, setNewPrecio] = useState(0);
  const [newDescripcionText, setNewDescripcionText] = useState("");
  const [newDescItems, setNewDescItems] = useState([]);

  useEffect(() => {
    const bodegaRef = ref(db, "nature/Awoo/Bodega");
    const listener = onValue(bodegaRef, (snapshot) => {
      const data = snapshot.val() || {};
      let total = 0;
      let totalCostos = 0;
      const arr = Object.keys(data).map((categoria) => {
        const subcats = data[categoria] || {};
        const subArr = Object.keys(subcats).map((subcat) => {
          const nodo = subcats[subcat] || {};
          const cantidad = Number(nodo.Cantidad ?? 0);
          const costo = Number(nodo.Costo ?? 0);
          const precioTop =
            nodo.Precio !== undefined ? Number(nodo.Precio) : undefined;

          let descripcionRaw = nodo.Descripción ?? nodo.Descripcion ?? "";
          const descripcionIsObject =
            descripcionRaw && typeof descripcionRaw === "object";
          let descripcionItems = [];

          if (descripcionIsObject) {
            descripcionItems = Object.keys(descripcionRaw).map((k) => {
              const child = descripcionRaw[k] || {};
              return {
                id: k,
                descripcion:
                  child.Descripción ??
                  child.Descripcion ??
                  String(child),
                precio: Number(child.Precio ?? 0),
              };
            });
          }

          const precioUsed =
            precioTop !== undefined
              ? precioTop
              : descripcionItems.length > 0
              ? descripcionItems[0].precio
              : 0;

          const costoTotal = cantidad * costo;
          const precioTotal = cantidad * precioUsed;
          const ganancia = precioTotal - costoTotal;
          total += precioTotal;
          totalCostos += costoTotal;


          return {
            nombre: subcat,
            descripcionIsObject,
            descripcionString: !descripcionIsObject
              ? String(descripcionRaw || "")
              : "",
            descripcionItems,
            cantidad,
            costo,
            precio: precioUsed,
            costoTotal,
            precioTotal,
            ganancia,
            precioTopLevel: precioTop,
          };
        });
        return { categoria, subcategorias: subArr };
      });

      setCostoGlobal(totalCostos);
      setBodega(arr);
      setTotalGlobal(total);
    });
    return () => off(bodegaRef);
  }, [db]);

  const formatNumber = (n) => Number(n || 0).toLocaleString("es-CO");
  const formatPrecio = (n) =>
    n === undefined || n === null ? "-" : `$${formatNumber(n)}`;

  const toggleExpand = (cat, sub) => {
    const k = `${cat}__${sub}`;
    setExpanded((p) => ({ ...p, [k]: !p[k] }));
  };

  const toggleShowItems = (cat, sub) => {
    const k = `${cat}__${sub}`;
    setShowItems((p) => ({ ...p, [k]: !p[k] }));
  };

  // ---- ADD DIALOG ----
  const openAddDialog = (cat) => {
    setAddForCategory(cat);
    setNewName("");
    setNewCantidad(0);
    setNewCosto(0);
    setNewPrecio(0);
    setNewDescripcionText("");
    setNewDescItems([]);
    setAddDialogOpen(true);
  };

  const closeAddDialog = () => setAddDialogOpen(false);

  const addDescItem = () => {
    setNewDescItems((s) => [
      ...s,
      { id: `item${s.length + 1}`, descripcion: "", precio: 0 },
    ]);
  };
  const removeDescItem = (i) => {
    setNewDescItems((s) => s.filter((_, idx) => idx !== i));
  };
  const updateDescItem = (i, f, v) => {
    setNewDescItems((s) => s.map((it, idx) => (idx === i ? { ...it, [f]: v } : it)));
  };

  const handleSaveNewSub = async () => {
    if (!addForCategory || !newName) return alert("Faltan datos");

    let descripcionFinal = "";
    if (newDescItems.length > 0) {
      const obj = {};
      newDescItems.forEach((it) => {
        obj[it.id || `item${Math.random()}`] = {
          Descripción: it.descripcion,
          Precio: Number(it.precio || 0),
        };
      });
      descripcionFinal = obj;
    } else if (newDescripcionText.trim() !== "") {
      descripcionFinal = newDescripcionText.trim();
    }

    const newData = {
      Cantidad: Number(newCantidad || 0),
      Costo: Number(newCosto || 0),
      Precio: Number(newPrecio || 0),
      Descripción: descripcionFinal,
    };

    try {
      await set(ref(db, `nature/Awoo/Bodega/${addForCategory}/${newName}`), newData);
      setAddDialogOpen(false);
      alert("✅ Subcategoría agregada");
    } catch (e) {
      alert("Error guardando: " + e.message);
    }
  };

  // ---- DELETE ----
  const openDeleteDialog = (cat) => {
    setDeleteForCategory(cat);
    setDeleteSubSelection("");
    setDeleteDialogOpen(true);
  };
  const closeDeleteDialog = () => setDeleteDialogOpen(false);
  const handleConfirmDeleteSub = async () => {
    if (!deleteForCategory || !deleteSubSelection) return;
    if (!window.confirm("¿Eliminar esta subcategoría?")) return;
    try {
      await remove(ref(db, `nature/Awoo/Bodega/${deleteForCategory}/${deleteSubSelection}`));
      setDeleteDialogOpen(false);
      alert("🗑️ Eliminado");
    } catch (e) {
      alert("Error: " + e.message);
    }
  };

  // ---- EDIT ----
  const openEditDialog = (cat, sub) => {
    setEditCategory(cat);
    setEditSubName(sub.nombre);
  
    // Si ya trae items los usamos, si trae string lo convertimos a 1 item, sino iniciamos 1 vacío
    const existingItems =
      (sub.descripcionItems && sub.descripcionItems.length > 0)
        ? sub.descripcionItems
        : sub.descripcionString
        ? [{ id: "item1", descripcion: sub.descripcionString, precio: 0 }]
        : [{ id: "item1", descripcion: "", precio: 0 }];
  
    const init = {
      cantidad: sub.cantidad,
      costo: sub.costo,
      precio: sub.precioTopLevel || sub.precio,
      descripcionString: sub.descripcionString,
      // forzamos siempre items estructurados en el edit
      descripcionItems: existingItems,
      descripcionIsObject: true,
    };
    setEditData(init);
    setEditChanged(false);
    setEditDialogOpen(true);
  };
  
  const closeEditDialog = () => setEditDialogOpen(false);

  const handleEditChange = (field, value) => {
    setEditData((p) => ({ ...p, [field]: value }));
    setEditChanged(true);
  };

  const addEditItem = () => {
    setEditData((p) => {
      const current = p?.descripcionItems || [];
      return {
        ...p,
        descripcionItems: [
          ...current,
          { id: `item${current.length + 1}`, descripcion: "", precio: 0 },
        ],
      };
    });
    setEditChanged(true);
  };
  
  const removeEditItem = (i) => {
    setEditData((p) => {
      const current = [...(p?.descripcionItems || [])];
      current.splice(i, 1);
      return { ...p, descripcionItems: current };
    });
    setEditChanged(true);
  };
  
  const updateEditItem = (i, f, v) => {
    setEditData((p) => {
      const current = (p?.descripcionItems || []).map((it, idx) =>
        idx === i ? { ...it, [f]: v } : it
      );
      return { ...p, descripcionItems: current };
    });
    setEditChanged(true);
  };
  

  const handleSaveEdit = async () => {
    if (!editCategory || !editSubName || !editData) return;

    let descripcionFinal = "";
    if (editData.descripcionIsObject) {
      const obj = {};
      (editData.descripcionItems || []).forEach((it) => {
        // evita ids vacíos: si it.id está vacío, generamos uno para guardar
        const idKey = it.id && String(it.id).trim() !== "" ? it.id : `item${Math.random().toString(36).slice(2, 8)}`;
        obj[idKey] = { Descripción: it.descripcion || "", Precio: Number(it.precio || 0) };
      });
      // Si no hay items, dejamos string vacío (o podrías dejar objeto vacío según prefieras)
      descripcionFinal = Object.keys(obj).length > 0 ? obj : "";
    } else if (editData.descripcionString?.trim()) {
      descripcionFinal = editData.descripcionString.trim();
    }
    

    const newData = {
      Cantidad: Number(editData.cantidad || 0),
      Costo: Number(editData.costo || 0),
      Precio: Number(editData.precio || 0),
      Descripción: descripcionFinal,
    };

    try {
      await set(ref(db, `nature/Awoo/Bodega/${editCategory}/${editSubName}`), newData);
      setEditDialogOpen(false);
      alert("✅ Cambios guardados");
    } catch (e) {
      alert("Error al guardar: " + e.message);
    }
  };

  // --------------------------------------------------
  return (
    <Box sx={{ backgroundColor: "#000", color: "#fff", minHeight: "100vh", p: 3 }}>
      <Typography variant="h5" align="center" sx={{ mb: 1 }}>
        🏭 Bodega - Implementos
      </Typography>

<Box sx={{ textAlign: "right", mb: 2 }}>
  <Typography variant="caption" color="grey.500">Total Global</Typography>
  <Typography variant="h6">{formatPrecio(totalGlobal)}</Typography>

  <Typography variant="caption" color="grey.500">Costo Global</Typography>
  <Typography variant="h6" sx={{ color: "#ff8080" }}>{formatPrecio(costoGlobal)}</Typography>

  <Typography variant="caption" color="grey.500">Ganancia Total</Typography>
  <Typography variant="h6" sx={{ color: "lime" }}>
    {formatPrecio(totalGlobal - costoGlobal)}
  </Typography>
</Box>


      {bodega.map((cat, i) => (
        <Box key={i} sx={{ backgroundColor: "#111", border: "1px solid #333", borderRadius: 2, p: 2, mb: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography sx={{ color: "cyan", fontWeight: 700 }}>{cat.categoria}</Typography>
            <Stack direction="row" spacing={1}>
              <Button color="success" variant="contained" onClick={() => openAddDialog(cat.categoria)} startIcon={<AddCircleOutlineIcon />}>Agregar</Button>
              <Button color="error" variant="contained" onClick={() => openDeleteDialog(cat.categoria)} startIcon={<DeleteOutlineIcon />}>Eliminar</Button>
            </Stack>
          </Box>

          {cat.subcategorias.map((sub, j) => {
            const key = `${cat.categoria}__${sub.nombre}`;
            const isOpen = !!expanded[key];
            const showItemList = !!showItems[key];

            return (
              <Box key={j} sx={{ backgroundColor: "#1a1a1a", borderRadius: 1, p: 1.5, mb: 1 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography
  sx={{
    fontWeight: 600,
    color: sub.costo === 0 ? "red" : "white",
  }}
>
  {sub.nombre}
</Typography>

                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Typography>📦 {formatNumber(sub.cantidad)}</Typography>
                    <Typography>💰 {formatPrecio(sub.precio)}</Typography>
                    <Typography sx={{ color: "#ffd166" }}>💲 {formatPrecio(sub.precioTotal)}</Typography>
                    <Typography sx={{ color: "#6cf", cursor: "pointer" }} onClick={() => toggleExpand(cat.categoria, sub.nombre)}>
                      {isOpen ? "⬆️ Ocultar" : "⬇️ Detalles"}
                    </Typography>
                    <Button size="small" color="info" variant="outlined" startIcon={<EditIcon />} onClick={() => openEditDialog(cat.categoria, sub)}>Modificar</Button>
                  </Box>
                </Box>

                {isOpen && (
  <Box
    sx={{
      mt: 1,
      display: "flex",
      flexDirection: "column",
      width: "100%",
    }}
  >
    {/* DATOS PRINCIPALES EN GRID */}
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 1,
        width: "100%",
      }}
    >
      <Typography>📦 Cantidad: {formatNumber(sub.cantidad)}</Typography>
      <Typography>💲 Costo und: {formatPrecio(sub.costo)}</Typography>
      <Typography>💰 Precio und: {formatPrecio(sub.precio)}</Typography>
      <Typography sx={{ color: sub.ganancia >= 0 ? "lime" : "red" }}>
        ⚖️ Ganancia: {formatPrecio(sub.ganancia)}
      </Typography>
    </Box>

    {/* DESCRIPCIÓN / ÍTEMS */}
    {sub.descripcionIsObject ? (
      <Box sx={{ mt: 1, width: "100%" }}>
        <Typography
          sx={{
            cursor: "pointer",
            textAlign: "center",
            color: "#ccc",
            fontWeight: 500,
            "&:hover": { color: "white" },
          }}
          onClick={() => toggleShowItems(cat.categoria, sub.nombre)}
        >
          📋 {sub.descripcionItems.length} ítems ({showItemList ? "ocultar" : "ver"})
        </Typography>

        {showItemList &&
          sub.descripcionItems.map((it) => (
            <Box
              key={it.id}
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                alignItems: "center",
                background: "#0f0f0f",
                p: 1,
                borderRadius: 1,
                mt: 0.5,
                width: "100%",
                gap: 1,
              }}
            >
              {/* Nodo (usando el id como nombre del nodo) */}
              <Typography
                sx={{
                  color: "#9fd3ff",
                  fontSize: ".85rem",
                  fontWeight: 500,
                }}
              >
                🧩 Nodo: {it.id}
              </Typography>

              {/* Descripción */}
              <Typography
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  color: "#ddd",
                }}
              >
                {it.descripcion}
              </Typography>

              {/* Precio */}
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#8f8",
                  fontWeight: 500,
                }}
              >
                💰 {formatPrecio(it.precio)}
              </Typography>
            </Box>
          ))}
      </Box>
    ) : (
      sub.descripcionString && (
        <Typography sx={{ mt: 1, color: "grey.400", width: "100%" }}>
          {sub.descripcionString}
        </Typography>
      )
    )}
  </Box>
)}


              </Box>
            );
          })}
        </Box>
      ))}

{/* ADD */}
<Dialog open={addDialogOpen} onClose={closeAddDialog} fullWidth maxWidth="md">
  <DialogTitle>🟢 Agregar nueva subcategoría en {addForCategory}</DialogTitle>
  <DialogContent>
    <TextField
      fullWidth
      label="Nombre de la subcategoría"
      value={newName}
      onChange={(e) => setNewName(e.target.value)}
      sx={{ mt: 1 }}
    />
    <TextField
      fullWidth
      label="Cantidad"
      type="number"
      value={newCantidad}
      onChange={(e) => setNewCantidad(Number(e.target.value))}
      sx={{ mt: 1 }}
    />
    <TextField
      fullWidth
      label="Costo unitario"
      type="number"
      value={newCosto}
      onChange={(e) => setNewCosto(Number(e.target.value))}
      sx={{ mt: 1 }}
    />
    <TextField
      fullWidth
      label="Precio unitario"
      type="number"
      value={newPrecio}
      onChange={(e) => setNewPrecio(Number(e.target.value))}
      sx={{ mt: 1 }}
    />

    {/* Ítems estructurados (siempre visibles) */}
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Ítems estructurados
      </Typography>
      <IconButton onClick={addDescItem} color="primary">
        <AddCircleOutlineIcon />
      </IconButton>

      {newDescItems.map((it, i) => (
        <Box
          key={i}
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            mt: 1,
          }}
        >
          <TextField
            label="ID (nodo)"
            value={it.id}
            onChange={(e) => updateDescItem(i, "id", e.target.value)}
            sx={{ width: 120 }}
          />
          <TextField
            label="Descripción"
            value={it.descripcion}
            onChange={(e) => updateDescItem(i, "descripcion", e.target.value)}
            fullWidth
          />
          <TextField
            label="Precio"
            type="number"
            value={it.precio}
            onChange={(e) => updateDescItem(i, "precio", Number(e.target.value))}
            sx={{ width: 120 }}
          />
          <IconButton color="error" onClick={() => removeDescItem(i)}>
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Box>
      ))}
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={closeAddDialog}>Cancelar</Button>
    <Button onClick={handleSaveNewSub} variant="contained" color="success">
      Guardar
    </Button>
  </DialogActions>
</Dialog>




      {/* DELETE */}
      <Dialog open={deleteDialogOpen} onClose={closeDeleteDialog} fullWidth>
        <DialogTitle>Eliminar subcategoría</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel>Subcategoría</InputLabel>
            <Select value={deleteSubSelection} onChange={(e) => setDeleteSubSelection(e.target.value)}>
              {bodega.find(b => b.categoria === deleteForCategory)?.subcategorias.map((s) => (
                <MenuItem key={s.nombre} value={s.nombre}>{s.nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog}>Cancelar</Button>
          <Button color="error" variant="contained" onClick={handleConfirmDeleteSub}>Eliminar</Button>
        </DialogActions>
      </Dialog>

{/* EDIT */}
<Dialog open={editDialogOpen} onClose={closeEditDialog} fullWidth maxWidth="md">
  <DialogTitle>✏️ Modificar {editSubName}</DialogTitle>
  {editData && (
    <DialogContent>
      <TextField
        fullWidth
        label="Cantidad"
        type="number"
        value={editData.cantidad}
        onChange={(e) => handleEditChange("cantidad", Number(e.target.value))}
        sx={{ mt: 1 }}
      />
      <TextField
        fullWidth
        label="Costo"
        type="number"
        value={editData.costo}
        onChange={(e) => handleEditChange("costo", Number(e.target.value))}
        sx={{ mt: 1 }}
      />
      <TextField
        fullWidth
        label="Precio"
        type="number"
        value={editData.precio}
        onChange={(e) => handleEditChange("precio", Number(e.target.value))}
        sx={{ mt: 1 }}
      />

      {/* ÍTEMS ESTRUCTURADOS (siempre visibles) */}
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2">Ítems estructurados</Typography>
        <IconButton onClick={addEditItem} color="primary">
          <AddCircleOutlineIcon />
        </IconButton>

        {(editData.descripcionItems && editData.descripcionItems.length > 0
          ? editData.descripcionItems
          : [{ id: "", descripcion: "", precio: 0 }]
        ).map((it, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              mt: 1,
            }}
          >
            <TextField
              label="ID (nodo)"
              value={it.id}
              onChange={(e) => updateEditItem(i, "id", e.target.value)}
              sx={{ width: 120 }}
            />
            <TextField
              label="Descripción"
              value={it.descripcion}
              onChange={(e) => updateEditItem(i, "descripcion", e.target.value)}
              fullWidth
            />
            <TextField
              label="Precio"
              type="number"
              value={it.precio}
              onChange={(e) => updateEditItem(i, "precio", Number(e.target.value))}
              sx={{ width: 120 }}
            />
            <IconButton color="error" onClick={() => removeEditItem(i)}>
              <RemoveCircleOutlineIcon />
            </IconButton>
          </Box>
        ))}
      </Box>
    </DialogContent>
  )}
  <DialogActions>
    <Button onClick={closeEditDialog}>Cancelar</Button>
    <Button
      onClick={handleSaveEdit}
      disabled={!editChanged}
      variant="contained"
      color="success"
    >
      Guardar cambios
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
}
